<template>
	<ValidationObserver ref="observer" v-slot="{ invalid, validated }" tag="form" novalidate class="social-login__form" @submit.prevent="handleForm">
		<c-deprecated-validated-input
			id="email-address"
			v-model.trim="email"
			type="email"
			placeholder="Email Address"
			name="Email Address"
			autocomplete="on"
			rules="required|email"
			:disabled="!!requiredUser"
			@blur="emailChanged"
		/>

		<c-deprecated-validated-input
			id="password"
			v-model="password"
			type="password"
			placeholder="Password"
			name="Password"
			autocomplete="on"
			rules="required"
		/>

		<c-callout v-if="showNoAccountError" type="error">
			<p v-if="!requiredOrg"> We couldn't find an account for this email address.<br> <router-link tag="a" :to="signupUrl" title="Sign up for Cognito Forms">Would you like to sign up</router-link>? </p>
			<p v-else> We couldn't find an account for this email address.</p>
		</c-callout>

		<c-callout v-else-if="showPasswordError" type="error">
			<p>Incorrect password.</p>
		</c-callout>

		<c-callout v-else-if="showMfaError" type="error">
			<p>This account has been locked. Please try again in one hour.</p>
		</c-callout>

		<c-callout v-else-if="showInvalidUserMessage" type="error">
			<p>Please log in as {{ requiredUser }}.</p>
		</c-callout>

		<c-callout v-else-if="showInvalidOrgMessage" type="error">
			<p>You are not a member of {{ requiredOrg }}.</p>
		</c-callout>

		<c-deprecated-checkbox
			id="remember-me"
			v-model="rememberMe"
			label="Remember Me"
			class="remember-me sz-2"
		/>

		<slot name="captcha" />

		<c-status-button
			class="button button--primary sz-4"
			title="Log In to Cognito Forms"
			type="submit"
			:status="status"
			:disabled="validated && invalid"
		>
			{{ buttonName }}
		</c-status-button>
	</ValidationObserver>
</template>

<script>
	import CCallout from '@cognitoforms/shared-components/src/components/content/Callout.vue';
	import CDeprecatedCheckbox from '@cognitoforms/shared-components/src/components/form-controls/DeprecatedCheckbox.vue';
	import CStatusButton from '@cognitoforms/shared-components/src/components/interaction/StatusButton.vue';
	import CDeprecatedValidatedInput from '@cognitoforms/shared-components/src/components/form-controls/DeprecatedValidatedInput.vue';
	import { ValidationObserver } from 'vee-validate';

	export default {
		name: 'EmailLogin',
		components: {
			CCallout,
			CDeprecatedCheckbox,
			CStatusButton,
			CDeprecatedValidatedInput,
			ValidationObserver
		},
		props: {
			status: { type: String, default: '' },
			buttonName: { type: String, default: '' },
			showPasswordError: { type: Boolean, default: false },
			showNoAccountError: { type: Boolean, default: false },
			showMfaError: { type: Boolean, default: false },
			prefilledEmail: { type: String, default: '' },
			requiredOrg: { type: String, default: '' },
			requiredUser: { type: String, default: '' },
			showInvalidOrgMessage: { type: Boolean, default: false },
			showInvalidUserMessage: { type: Boolean, default: false }
		},
		data() {
			return {
				email: this.prefilledEmail || '',
				password: '',
				rememberMe: false
			};
		},
		computed: {
			signupUrl() {
				return '/signup' + location.search;
			}
		},
		methods: {
			async handleForm(email, password, rememberMe) {
				const valid = await this.$refs.observer.validate();
				if (valid)
					this.$emit('submitted', { email: this.email, password: this.password, rememberMe: this.rememberMe });
			},
			cancelled() {
				this.$emit('cancelled');
			},
			emailChanged() {
				this.$emit('email-changed', this.email);
			}
		}
	};
</script>